/**
 * 路口图片实体
*/
import React, { Component } from 'react';
import { Modal, Input,Row,Col, message, 
    Select,Image, Upload,Radio,
    Slider,
} from 'antd';
// import ImgCrop from 'antd-img-crop';
import $ from 'jquery';
import { PlusOutlined } from '@ant-design/icons';
import { AddRequestHeaders,UjoinParams,AliyunOSSclient,
    getBase64, winWidth, UUID } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import LOGO1 from '../../images/logo_location_1.png';
import LOGO2 from '../../images/logo_location_2.png';

const MODULENAME = '路口图片'

const Option = Select.Option;

const uploadButton = (
    <button style={{
        border: 0,
        background: 'none',
        cursor: 'pointer'
    }} type="button"
    >
        <PlusOutlined />
        <div style={{ marginTop: 8,}}>上传图片</div>
    </button>
);

/**
 * 根据logo编码，返回对应的logo图片
 * @param {*} number 
 * @returns 
 */
const getLogoImage = (number) => {
    switch(number){
        case 1:
            return LOGO1;
        case 2:
            return LOGO2;
        default:
            return null;
    }
}

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            intersectionUlid: '',
            intersectionName: '',
            name: '',
            url: '',
            path: '',
            previewOpen: false,
            previewImage: '',
            fileList: [],
            mainImageUrl: '',
            imageLists: [],
            imageMainLists: [],   //    主图片列表
            logoImages: [],       //    悬浮logo图
            logoNumber: 1,
            isMain: 1,            //    是否主图
            mainUlid: '',         //    主图ulid
            x: 0,                 //    x-偏移量
            y: 0,                 //    y-偏移量
            rotationAngle: 0,     //    旋转角度
        }
    }

    changeIntersectionUlid = (value, operations) =>{
        if(value){
            //  获取图片列表
            this.getImageLists(value);
        }
        this.setState({ 
            intersectionUlid: value,
            intersectionName: operations.children,
            mainUlid: '',
        });}
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeLogoNumber = (value) =>{this.setState({logoNumber: value});}
    setPreviewOpen = (value) =>{this.setState({previewOpen: value});}
    setPreviewImage = (value) =>{this.setState({previewImage: value});}
    changeIsMain = (e) =>{this.setState({isMain: e.target.value});}
    changeMainUlid = (value) =>{this.setState({ mainUlid: value});}
    changeRotationAngle = (value) =>{
        //  旋转角度
        let logoImages = this.state.logoImages;
        for(let i=0;i<logoImages.length;i++){
            if(logoImages[i].name === this.state.name){
                logoImages[i].rotation_angle = this.state.rotationAngle;
                break;
            }
        }
        this.setState({ 
            rotationAngle: value,
            logoImages: logoImages,
        });}
    /**
     * 获取主图
     * @param {*} value 
     */
    setMainImageUrl = (value) =>{this.setState({mainImageUrl: value});}

    handlePreview = (file) =>{
        if(!file.preview) {
            //  转换图片，用于缩略图展示
            getBase64(file.originFileObj, (imageObj) => {
                file.preview = imageObj;
            });
        }
        this.setPreviewImage(file.preview || file.url);
        this.setPreviewOpen(true);
    }

    /**
     * 定位logo位置
     * @param {*} e 
     */
    fixLogoLocation = (e) => {
        //  获取蒙皮滚动条位置
        let wrapDiv = document.getElementsByClassName('ant-modal-wrap');
        let wrapTop = wrapDiv[0].scrollTop?wrapDiv[0].scrollTop:0;

        //  判断名称是否为空
        if(!this.state.name){
            message.error('请输入名称!');
            return;
        }
        
        /**
         * 数字说明
         * 648：窗口宽度
         * 40：logo宽度
         * 60：logo高度
         * 26：内边距与边框24+2
         * 272：图片之上的高度
         * wrapTop：蒙皮滚动条位置
         */
        let x = e.clientX - (winWidth-648)/2 - 26 - 40;
        let y = e.clientY - 272 - 60 + wrapTop;
        //  判读是否存在
        let isExist = false;
        let logoImages = this.state.logoImages;
        for(let i=0;i<logoImages.length;i++){
            if(logoImages[i].name === this.state.name){
                isExist = true;
                logoImages[i].x = x;
                logoImages[i].y = y;
                logoImages[i].logo_number = this.state.logoNumber;
                logoImages[i].rotation_angle = this.state.rotationAngle;
                break;
            }
        }
        if(!isExist){
            logoImages.push({
                name: this.state.name,
                x: x,
                y: y,
                logo_number: this.state.logoNumber,
                rotation_angle:  this.state.rotationAngle,
            });
        }
        this.setState({ 
            x: x,
            y: y,
            logoImages: logoImages,
         });
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    aliyunOSSUpload = (file) =>{
        const _this = this;
        var params = {
            'oss': 'PutObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onloadend = () => {
                                // _this.setState({fileName: file.name});
                                //  路径由以下部分组成
                                //  项目代码+组织前缀+路口Ulid+附件名（去除空格）
                                var path = CNF.projectCode.toLowerCase() + '/' 
                                path += _this.props.preGroup + '/' 
                                path += _this.state.intersectionUlid + '/'
                                path += UUID;
                                path += '.' + file.name.replace(/\s/g, '').split('.').slice(-1)[0];
                                AliyunOSSclient(token).multipartUpload(path, file, 
                                {
                                    //  获取分片上传进度、断点和返回值
                                    progress: (p, cpt, res)=>{
                                        //  获取最新的文件列表
                                        let newFileList = _this.state.fileList;
                                        //  获取最新的文件实体
                                        let newFile = newFileList[newFileList.length - 1];
                                        newFile.percent = parseInt(p * 100);
                                        if(p === 1){
                                            //  文件上传完成
                                            newFile.uid = '1';
                                            newFile.status = 'done';
                                            newFile.url = 'https://cfmsoss.oss-cn-shenzhen.aliyuncs.com/' + path;
                                            newFile.path = path;
                                        }
                                        newFileList[newFileList.length - 1] = newFile;
                                        _this.setState({ fileList: newFileList });
                                    }, 
                                    //  分分片数量
                                    parallel: Math.ceil(file.size/1024/1024),
                                    //  设置分片大小，默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    //  获取url
                                    let url = path
                                    if(result.res.status === 200){
                                        url = result.res.requestUrls[0].split('?')[0];
                                    }
                                    //  获取文件名，去掉后缀
                                    let arr = file.name.replace(/\s/g, '').split('.');
                                    let fileName = arr.slice(0, arr.length - 1).join('.');
                                    //  存储路径
                                    _this.setState({ 
                                        name: fileName,
                                        path: path, 
                                        url: url 
                                    });
                                }).catch((e) =>{
                                    //  上传失败
                                    console.log(e);
                                    message.error(file.name + ' 上传失败！');
                                });
                            }
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
        return false
    }

    /**
     * 从阿里云下载
     * @param {*} file
     */
    aliyunOSSDownload = (file) =>{
        const _this = this;
        
        var params = {
            'oss': 'GetObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        //  去掉路径‘/’
                        let result = AliyunOSSclient(token).signatureUrl(file.path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + file.name + '"'
                            }
                        });
                        let fileList = [{
                            url: result,
                            preview: result,
                            name: file.name,
                            status: 'done',
                            percent: 100,
                            path: file.path,
                            uid: file.key,
                        }];
                        _this.setState({ fileList: fileList,});
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    /**
     * 从阿里云获取主图
     * @param {*} path 
     * @param {*} name 
     */
    aliyunOSSGetMainImage = (path, name) =>{
        const _this = this;
        
        var params = {
            'oss': 'GetObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        //  去掉路径‘/’
                        let result = AliyunOSSclient(token).signatureUrl(path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + name + '"'
                            }
                        });
                        _this.setMainImageUrl(result);
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    /**
     * 从阿里云删除
     * @param {*} file 
     * @returns 
     */
    aliyunOSSDelete = (file) => {
        var params = {
            'oss': 'DeleteObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        AliyunOSSclient(token).delete(file.path);
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
        return false
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    beforeUpload = (file) =>{
        //  判断格式
        if(!['image/png','image/jpg','image/jpeg'].includes(file.type)){
            message.error('上传图片格式错误！', 1.5);
            return false;
        }
        if (file.size > 104857600){
            message.error('上传附近超过10M，建议拆分文件！', 1.5);
            return false;
        }
        return true;
    }

    /**
     * 上传图片
     * @param {*} file 
     */
    uploadImage = (file) =>{
        //  图片上传至阿里云前动作
        this.aliyunOSSUpload(file);
    }

    /**
     * 获取路口图片列表
     * @param {*} intersectionUlid 
     */
    getImageLists = (intersectionUlid) => {
        const _this = this;
        const params = {
            'intersection_ulid': intersectionUlid,
            'page_size': CNF.pageSize * 10,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersection/images${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        let d = [];
                        let logoImages = [];
                        let mainUlid = _this.state.mainUlid;
                        let mainFilePath = '';
                        let mainFileName = '';
                        //  确定主图ulid
                        for(let i=0; i<data.dat.length; i++){
                            let item = data.dat[i];
                            //  如果主图已存在，则使用主图ulid，修改时用，反之则新增时用。
                            if (item.is_main){
                                d.push(item);
                                if(!mainUlid && !_this.props.record){
                                    //  默认获取第一个主图
                                    mainUlid = item.key;
                                    mainFilePath = item.path;
                                    mainFileName = item.name;
                                }
                            }
                            //  如果是修改附图，则还需要下载主图
                            if(_this.props.record && item.key === _this.state.mainUlid){
                                mainFilePath = item.path;
                                mainFileName = item.name;
                            }
                        }
                        //  获取主图logo图片
                        for(let i=0; i<data.dat.length; i++){
                            let item = data.dat[i];
                            if(mainUlid === item.main_ulid){
                                //  获取主图的logo图片
                                logoImages.push({
                                    name: item.name,
                                    x: item.x,
                                    y: item.y,
                                    logo_number: item.logo_number,
                                    rotation_angle:  item.rotation_angle,
                                });
                            }
                        }

                        _this.setState({
                            imageLists: data.dat,
                            imageMainLists: d,
                            mainUlid: mainUlid,
                            logoImages: logoImages,
                        });
                        _this.aliyunOSSGetMainImage(mainFilePath, mainFileName);
                    }else{
                        _this.setState({
                            imageLists: [],
                            imageMainLists: [],
                            mainUlid: '',
                            logoImages: [],
                        });
                    }
                    
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}intersection/images`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'intersection_ulid': this.state.intersectionUlid,
                'intersection_name': this.state.intersectionName,
                'name': this.state.name,
                'path': this.state.path,
                'url': this.state.url,
                'logo_number': this.state.logoNumber,
                'is_main': this.state.isMain,            
                'main_ulid': this.state.mainUlid,
                'x': this.state.x,                 
                'y': this.state.y,     
                'rotation_angle': this.state.rotationAngle,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}intersection/images/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'intersection_ulid': this.state.intersectionUlid,
                'intersection_name': this.state.intersectionName,
                'name': this.state.name,
                'path': this.state.path,
                'url': this.state.url,
                'logo_number': this.state.logoNumber,
                'is_main': this.state.isMain,            
                'main_ulid': this.state.mainUlid,
                'x': this.state.x,                 
                'y': this.state.y,     
                'rotation_angle': this.state.rotationAngle,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        if(this.state.intersectionUlid === ''){
            message.error('路口不能为空！');
            return;
        }
        if(this.state.name === ''){
            message.error('图片名称不能为空！');
            return;
        }
        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            intersectionUlid: '',
            intersectionName: '',
            name: '',
            url: '',
            path: '',
            previewOpen: false,
            previewImage: '',
            fileList: [],
            mainImageUrl: '',
            imageLists: [],
            imageMainLists: [],   //    主图片列表
            logoImages: [],       //    悬浮logo图
            logoNumber: 1,
            isMain: 1,            //    是否主图
            mainUlid: '',         //    主图ulid
            x: 0,                 //    x-偏移量
            y: 0,                 //    y-偏移量
            rotationAngle: 0,     //    旋转角度
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                intersectionUlid: this.props.record.intersection_ulid,
                intersectionName: this.props.record.intersection_name,
                name: this.props.record.name,
                path: this.props.record.path,
                url: this.props.record.url,
                isMain: this.props.record.is_main,
                mainUlid: this.props.record.main_ulid,
                x: this.props.record.x,
                y: this.props.record.y,
                rotationAngle: this.props.record.rotation_angle,
                logoNumber: this.props.record.logo_number,
            });
            //  从阿里云上获取图片
            this.aliyunOSSDownload(this.props.record);
            //  附图，则需要获取路口图片列表
            if(!this.props.record.is_main){
                this.getImageLists(this.props.record.intersection_ulid);
            }
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={648}
                    style={{ top: 0 }}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    className='intersection-image-modal'
                    // mask={false}
                    okText='确认'
                    cancelText='取消'
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5,lineHeight: 2.2 }}>
                        <Col span={4}>所在路口：</Col>
                        <Col span={20}>
                            <Select 
                                showSearch
                                value={this.state.intersectionUlid.toString()}
                                style={{ width: '100%' }} 
                                onChange={this.changeIntersectionUlid}
                                disabled={this.props.record?true:this.state.loading}
                                filterOption={(input, option) =>
                                    option.props.children.indexOf(input) >= 0
                                }
                            >
                                <Option value=''>选择路口</Option>
                                {
                                    this.props.intersectionDDList.length && this.props.intersectionDDList.map((item) => {
                                        return <Option key={item['key']} value={item['key'].toString()}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={4}>图片名称：</Col>
                        <Col span={20}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={4}>是否主图：</Col>
                        <Col span={6}>
                            <Radio.Group 
                                onChange={this.changeIsMain} 
                                disabled={this.props.record?true:this.state.loading}
                                value={this.state.isMain}>
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Col>
                        {
                            !this.state.isMain?<>
                                <Col span={4}>选择主图：</Col>
                                <Col span={10}>
                                    <Select 
                                        showSearch
                                        value={this.state.mainUlid.toString()}
                                        style={{ width: '100%' }} 
                                        onChange={this.changeMainUlid}
                                        disabled={this.state.loading}
                                        filterOption={(input, option) =>
                                            option.props.children.indexOf(input) >= 0
                                        }
                                    >
                                        {
                                            this.state.imageMainLists.length && this.state.imageMainLists.map((item) => {
                                                return <Option key={item['key']} value={item['key'].toString()} path={item['path']} name={item['name']}>{item['name']}</Option>
                                            })
                                        }
                                    </Select>
                                </Col>
                            </>:''
                        }
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5} offset={4}>
                            {/* <ImgCrop modalOk='确认' modalCancel='取消'> */}
                            <Upload
                                beforeUpload={this.beforeUpload}
                                name='file'
                                listType='picture-card'
                                icon={<PlusOutlined />}
                                customRequest={(option)=>{this.uploadImage(option.file);}}
                                // disabled={this.state.intersectionUlid?false:true}
                                fileList={this.state.fileList}
                                // onPreview={this.handlePreview}
                                preview={false}
                                onChange={({fileList: newFileList})=>{
                                    this.setState({fileList: newFileList});
                                }}
                                onRemove={(file)=>{
                                    //  从阿里云上删除
                                    this.aliyunOSSDelete(file);
                                }}
                            >
                                {this.state.fileList.length >=1 ? null: uploadButton}
                            </Upload>
                            {/* </ImgCrop> */}
                            {this.state.previewImage && (
                                <Image
                                    wrapperStyle={{
                                        display: 'none',
                                    }}
                                    preview={{
                                        visible: this.state.previewOpen,
                                        onVisibleChange: (visible) => this.setPreviewOpen(visible),
                                        afterOpenChange: (visible) => !visible && this.setPreviewImage(''),
                                    }}
                                    src={this.state.previewImage}
                                />
                            )}
                        </Col>
                        {
                            !this.state.isMain?<>
                                <Col span={1} style={{position:'relative' }}>
                                    <div style={{ 
                                            background: '#FBFBFB',
                                            border: this.state.logoNumber === 1?'1px solid #FF904D':'1px dashed #d9d9d9',
                                            width:'100%',
                                            padding: 2, 
                                            borderRadius: 4,
                                            position: 'absolute',
                                            bottom: 0,
                                            cursor: 'pointer',
                                        }}
                                        onClick={()=>{this.changeLogoNumber(1);}}
                                    >
                                        <Image width='100%' preview={false} src={LOGO1}/>
                                    </div>
                                </Col>
                                <Col span={1} offset={1} style={{position:'relative' }}>
                                    <div style={{ 
                                            background: '#FBFBFB',
                                            border: this.state.logoNumber === 2?'1px solid #FF904D':'1px dashed #d9d9d9',
                                            width:'100%',
                                            padding: 2, 
                                            borderRadius: 4,
                                            position: 'absolute',
                                            bottom: 0,
                                            cursor: 'pointer',
                                        }}
                                        onClick={()=>{this.changeLogoNumber(2);}}
                                    >
                                        <Image width='100%' preview={false} src={LOGO2}/>
                                    </div>
                                </Col>
                                <Col span={4} offset={2} style={{position:'relative' }}>
                                    <div style={{ 
                                            padding: 2, 
                                            borderRadius: 4,
                                            position: 'absolute',
                                            bottom: 0,
                                        }}
                                    >旋转角度：</div>
                                </Col>
                                <Col span={6} style={{position:'relative' }}>
                                    <div style={{ 
                                            width:'100%',
                                            position: 'absolute',
                                            bottom: 0,
                                        }}
                                    >
                                        <Slider marks={{
                                            0: '0°',
                                            90: '90°',
                                            180: '180°',
                                            270: '270°',
                                        }}
                                            styles={{  width: '100%' }}
                                            min={0}
                                            max={360}
                                            value={this.state.rotationAngle}
                                            onChange={this.changeRotationAngle}
                                            step={1} 
                                        />
                                        {/* <InputNumber 
                                            size='small'
                                            min={0} 
                                            max={360} 
                                            value={this.state.rotationAngle} 
                                            onChange={this.changeRotationAngle}
                                        /> */}
                                    </div>
                                </Col>
                            </>:''
                        }
                    </Row>
                    {
                        !this.state.isMain?<Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                            <Col span={24}>
                                <div
                                    style={{
                                        position: 'relative',
                                        cursor: 'pointer',
                                        height: 'auto',
                                        width: '100%',
                                    }}
                                    onClick={(e)=>{this.fixLogoLocation(e);}}
                                >
                                    <Image width={600} preview={false} src={this.state.mainImageUrl} />
                                    {
                                        this.state.logoImages && this.state.logoImages.map((item, index)=>{
                                            return <div key={index} style={{
                                                position: 'absolute',
                                                top: item.y,
                                                left: item.x,
                                                width: 40,
                                                height: 60,
                                                border:  this.state.name===item.name?'solid 1px #FF904D':'',
                                                transform: 'rotate(' + item.rotation_angle + 'deg)'
                                            }}>
                                                <Image width={40} height={60} preview={false} src={getLogoImage(item.logo_number)}/>
                                            </div>
                                        })
                                    }
                                </div>
                            </Col>
                        </Row>:''
                    }
                    
                </Modal>
            </div>
        );
    }
}

export default Entity